import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import AppButton from "components/app-button";

/* Deletion happens at three different scopes here - a whole calendar (every year of a
   region), a single year, or one holiday inside a year - and only the caller knows which
   request that is. The caller therefore hands over the copy plus an async onConfirm that
   resolves truthy on success, and this modal owns nothing but the confirmation itself. */
export const AppConfirmDeleteHolidayCalendarModal = (props, ref) => {
	const [visible, setVisible] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [config, setConfig] = useState({});

	const onHandleShow = useCallback((data) => {
		setConfig(data || {});
		setVisible(true);
	}, []);

	const onHandleDismiss = useCallback(() => {
		setVisible(false);
		setIsSubmitting(false);
	}, []);

	//prettier-ignore
	const onHandleConfirm = useCallback(async () => {
		if (!config.onConfirm) return;

		setIsSubmitting(true);

		const response = await config.onConfirm();

		setIsSubmitting(false);

		if (response) onHandleDismiss();
	}, [config, onHandleDismiss]);

	//prettier-ignore
	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	return (
		<Modal classes={{ root: "app-confirm-delete-holiday-calendar-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="confirm-delete-holiday-calendar-modal" aria-describedby="confirm-delete-holiday-calendar-modal">
			<div className="confirm-delete-holiday-calendar-modal">
				<div className="confirm-delete-holiday-calendar-modal__main">
					<div className="confirm-delete-holiday-calendar-modal__header">
						<p className="confirm-delete-holiday-calendar-modal__title">{config.title || "Confirm Deletion"}</p>
						<p className="confirm-delete-holiday-calendar-modal__description">{config.description}</p>
					</div>

					<div className="confirm-delete-holiday-calendar-modal__body">
						<div className="confirm-delete-holiday-calendar-modal__button-container">
							<AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} disabled={isSubmitting} />
							<AppButton type="button" className="confirm-delete-holiday-calendar-modal__destructive" label={config.confirmLabel || "Delete"} onClick={onHandleConfirm} disabled={isSubmitting} />
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default memo(forwardRef(AppConfirmDeleteHolidayCalendarModal));

AppConfirmDeleteHolidayCalendarModal.propTypes = {
	ref: PropTypes.object,
};
